import { Utilities as U } from "@shared/utilities/utilities.model";
// import { InnerMessage } from "../service/inner-messages.service";
const env = require('@assets/data/appConfig.json');

export class ErrorResponse {
	timestamp:    number;
	error?:		    string;
	details?:     any;
	description?: any;
	message: 	    string;
	path?: 		    string;
	code: 		    SharedMessagesCode;
	status: 	    number;

	constructor(obj: any) {
		
		if (U.isEmpty(obj)) {
			return;
		}

		try	{

			// conversione in json - a volte non viene fatta prima
			if (obj._body) {
				obj = obj.json();
			}

			Object.assign(this, obj);
			this.status = this.status || obj.statusCode;

			// const body = obj._body;
			// Object.freeze(body);
			// Object.assign(this, JSON.parse(body));
			
			// if (U.isEmpty(this.status) && U.isEmpty(obj.statusCode)) {
			// 	this.status = obj.statusCode;
			// }
		
		} catch (e) {
			
			if (obj.status) {
				this.status = obj.status;
			}
		}		
	}

	hasStatusCode(statusCodeList: number[]): boolean {

		return statusCodeList.includes(this.status);
	}

	/**
	 * Restituisce il messaggio tradotto in base alla lingua e al modulo
	 * 
	 * per colpa di un problema di dipendenza ciclica, non si può importare ModuleService
	 * getMessageTranslated(module: Module): string {
	 * 
	 * @param {string} uuid
	 * @returns {string}
	 */
	getMessageTranslated(module: string): string {

		const context = module;
		const language = env.SERVER_DATE_LOCATION;

		// console.log(context, language);
		if (!context || !language) {
			return '';
		}
		
		// const messagesList = require(`@shared/service/message-manager/messages/${context}/${context}-messages.${language}.json`);
		const messagesList = require(`app/shared/service/message-manager/messages/authority/authority-messages.it.json`);

		if (!messagesList) {
			return '';
		}

		const regex = /\('([^']+)'\)/g;
		let match;
		const params: string[] = [];

		while ((match = regex.exec(this.message)) !== null) {
			params.push(match[1]);
		}

		const output = messagesList[this.code];
		
		if (!output) {
			// return messagesList[InnerMessage.GENERIC_ERROR];
			return messagesList['GENERIC_ERROR'];
		}

		return (params) ? output.printf(...params) : output;
	}
}

export enum SharedMessagesCode {
	FILE_UPLOAD_NAME_NOT_VALID = 'FILE_UPLOAD_NAME_NOT_VALID',
}
